// src/api/order.api.ts
import { get, post, put, del } from './client';
import {
  ApiResponse,
  PaginatedResponse,
  Order,
  CreateOrderDto,
  CreatePosOrderDto,
  UpdateOrderStatusDto,
  OrderQueryParams,
  OrderStatistics,
} from '../types';
import { cartApi } from './cart.api';

// Helper to get session header
const getSessionHeader = () => {
  const sessionId = cartApi.getSessionId();
  return sessionId ? { 'x-session-id': sessionId } : {};
};

export const orderApi = {
  // ============= Customer Endpoints =============
  
  // إنشاء طلب جديد
  createOrder: (data: CreateOrderDto) => {
    return post<ApiResponse<Order>>('/orders', data, { headers: getSessionHeader() });
  },

  // تتبع الطلب
  trackOrder: (orderNumber: string, phone: string) => {
    return get<ApiResponse<Order>>(`/orders/track/${orderNumber}`, {
      params: { phone },
    });
  },

  // إلغاء الطلب (للعميل)
  cancelOrderByCustomer: (orderId: string, phone: string) => {
    return post<ApiResponse<Order>>(`/orders/${orderId}/cancel`, { phone });
  },

  // ============= Restaurant Endpoints =============
  
  // الحصول على جميع طلبات المطعم
  getRestaurantOrders: (params?: OrderQueryParams) => {
    return get<PaginatedResponse<Order>>('/orders/restaurant/all', { params });
  },

  // الحصول على الطلب النشط لطاولة
  getActiveTableOrder: (tableId: string) => {
    return get<ApiResponse<Order>>(`/orders/restaurant/table/${tableId}/active`);
  },

  // إنشاء طلب كاشير
  createPosOrder: (data: CreatePosOrderDto) => {
    return post<ApiResponse<Order>>('/orders/restaurant/pos', data);
  },

  // الحصول على تفاصيل طلب
  getOrderById: (id: string) => {
    return get<ApiResponse<Order>>(`/orders/restaurant/${id}`);
  },

  // تحديث حالة الطلب
  updateOrderStatus: (id: string, data: UpdateOrderStatusDto) => {
    return put<ApiResponse<Order>>(`/orders/restaurant/${id}/status`, data);
  },

  // إلغاء الطلب (للمطعم)
  cancelOrderByRestaurant: (id: string) => {
    return del<ApiResponse<Order>>(`/orders/restaurant/${id}`);
  },

  // إحصائيات الطلبات
  getOrderStatistics: (days?: number) => {
    return get<ApiResponse<OrderStatistics>>('/orders/restaurant/statistics', {
      params: { days },
    });
  },
};